import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addMedia, addResponse } from '../actions';
import { CloudinaryData } from '../types';

export const useInsertMediaHandler = () => {
  const dispatch = useDispatch();
  return useCallback(
    (data: CloudinaryData) => {
      if (data.assets.length) {
        const media = data.assets.map((asset) => {
          return {
            // eslint-ignore-next-line camelcase
            type: asset.resource_type,
            // eslint-ignore-next-line camelcase
            url: asset.derived ? asset.derived[0].secure_url : asset.secure_url,
          };
        });
        dispatch(addMedia(media));
        dispatch(addResponse(data.assets));
      }
    },
    [dispatch]
  );
};
